import axios from "axios";
import {getAuthorizationHeader} from "@/helpers/kiuru-http";

class Config {

    /**
     * Asynchronously loads configuration data from the specified base URL and stores it in the localStorage.
     *
     * @param {string} baseURL - The base URL for the configuration data.
     * @throws {Error} If the request to fetch the configuration data fails.
     * @returns {Promise<void>} A promise that resolves when the configuration data is successfully loaded and stored in localStorage.
     */
    async loadConfig(baseURL) {
        console.log("Loading configuration from " + baseURL + "config/list")
        try {
            let url = baseURL + "config/list";
            let headers = getAuthorizationHeader();
            let response = await axios.get(url, {
                headers: headers,
                timeout: 30000
            });

            let json = JSON.stringify(response.data);
            localStorage.setItem('config', json);
            return Promise.resolve();
        } catch (error) {
            console.log("Failed to load config", error);
            throw error;
        }
    }

    /**
     * Retrieves the configuration data from the localStorage. If the configuration data is not available,
     * a default configuration object is returned.
     *
     * @returns {Object} The configuration data retrieved from localStorage or a default configuration object if not present.
     */
    getConfig() {
        // return config from local storage
        let json = localStorage.getItem("config");
        if (json != null) {
            return JSON.parse(json)
        } else {
            return {
                "ap_attributes": [],
                "mu_attributes": ["GivenName", "Surname", "Organization", "Country", "EmailAddress", "StateOrProvince", "Language"],
                "enabled_components": [],
                "disabled_menus": [],
                "sim_enabled": false,
                "app_enabled": false,
                "futurae_enabled": false,
                "rssp_enabled": false,
                "cluster_enabled": false,
                "arabic_enabled": false,
                "musaplink_enabled": false,
                "ap_export_upload_enabled": false,
                "is_sim_prov_notes_enabled": false,
                "vid_enabled": false,
                "ap_services_enabled": false,
                "cert_renew_enabled": true,
            }
        }
    }

}

export default new Config();
